//2025-05-03

import React from "react";
import { Link } from "react-router-dom";


const Treinos = ({treinos}) => {

  return (
    <main className="content px-2 bg-light">
      <div className="py-2">
        <h3>Treinos</h3>
      </div>

      {treinos.map((t, index) => {
        return (
          <Link to={"/treinos/" + t._id}>
            <div className="row">
              <div className="col-12 col-sm-6 col-xl-4 mb-2">
                <div className="card border-0 shadow">
                  <div className="card-body">
                    <div className="row d-block d-xl-flex align-items-center">
                      <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-center">
                        <h3 className="fw-extrabold h5 text-black">{t.nomeTreino}</h3>
                      </div>
                    </div>
                    <div className="row d-block d-xl-flex align-items-center">
                      <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                        <p>{t.objectivo}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        );
      })}
    </main>
  )
};


export default Treinos;
